export function enterpriseNameValidator(value: string) {
  if (value.length <= 1) {
    return 'An enterprise name must be over 1 character in length.';
  }
  return undefined;
}
